<template>
  <div>
    <el-card class="">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('goldWithdrawal.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="goldWithdrawalInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input v-model="goldWithdrawalInfo.conditions.goldName"
                :placeholder="$t('goldWithdrawal.pleaseSelectAccountName')" />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input v-model="goldWithdrawalInfo.conditions.amount"
                :placeholder="$t('goldWithdrawal.pleaseSelectWithdrawalAmount')" />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input v-model="goldWithdrawalInfo.conditions.applyUserName"
                :placeholder="$t('goldWithdrawal.pleaseSelectApplicant')" />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input v-model="goldWithdrawalInfo.conditions.applyUserTel"
                :placeholder="$t('goldWithdrawal.pleaseSelectApplicantPhone')" />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryGoldWithdrawalMethod">
              <i class="el-icon-search"></i>
              <span>{{ $t('goldWithdrawal.query') }}</span>
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('goldWithdrawal.goldWithdrawal') }}</div>
        <el-button type="primary" size="small" @click="_openApplyGoldWithdrawalModal">
          {{ $t('goldWithdrawal.applyWithdrawal') }}
        </el-button>
      </div>
      <div class="">
        <el-table :data="goldWithdrawalInfo.goldWithdrawals" border style="width: 100%">
          <el-table-column prop="gwId" :label="$t('goldWithdrawal.id')" align="center" />
          <el-table-column prop="goldId" :label="$t('goldWithdrawal.goldId')" align="center" />
          <el-table-column prop="goldName" :label="$t('goldWithdrawal.accountName')" align="center" />
          <el-table-column prop="communityId" :label="$t('goldWithdrawal.communityId')" align="center" />
          <el-table-column prop="amount" :label="$t('goldWithdrawal.withdrawalAmount')" align="center" />
          <el-table-column prop="applyUserName" :label="$t('goldWithdrawal.applicant')" align="center" />
          <el-table-column prop="applyUserTel" :label="$t('goldWithdrawal.applicantPhone')" align="center" />
          <el-table-column prop="bankNum" :label="$t('goldWithdrawal.bankAccount')" align="center" />
          <el-table-column prop="bankNumName" :label="$t('goldWithdrawal.accountName')" align="center" />
          <el-table-column prop="bankName" :label="$t('goldWithdrawal.bankName')" align="center" />
          <el-table-column prop="remark" :label="$t('goldWithdrawal.applicationDescription')" align="center" />
          <el-table-column prop="stateName" :label="$t('goldWithdrawal.status')" align="center" />
          <el-table-column prop="stateMsg" :label="$t('goldWithdrawal.auditDescription')" align="center" />
          <el-table-column :label="$t('goldWithdrawal.operation')" align="center">
            <template #default="scope">
              <el-button-group v-if="scope.row.state === 'W'">
                <el-button size="mini" @click="_openEditGoldWithdrawalModel(scope.row)">
                  {{ $t('goldWithdrawal.audit') }}
                </el-button>
              </el-button-group>
              <el-button size="mini" @click="_openDeleteGoldWithdrawalModel(scope.row)">
                {{ $t('goldWithdrawal.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="goldWithdrawalInfo.conditions.page"
          :page-size="goldWithdrawalInfo.conditions.row" layout="total, prev, pager, next"
          :total="goldWithdrawalInfo.total">
        </el-pagination>
      </div>
    </el-card>

    <audit-gold-withdrawal ref="auditGoldWithdrawalRef" @refresh="queryGoldWithdrawal" />
    <delete-gold-withdrawal ref="deleteGoldWithdrawalRef" @refresh="queryGoldWithdrawal" />
  </div>
</template>

<script>
import { listGoldWithdrawal } from '@/api/admin/goldWithdrawal/goldWithdrawalApi'
import AuditGoldWithdrawal from '@/components/admin/auditGoldWithdrawal/auditGoldWithdrawal.vue'
import DeleteGoldWithdrawal from '@/components/admin/deleteGoldWithdrawal/deleteGoldWithdrawal.vue'

export default {
  name: 'GoldWithdrawal',
  components: {
    AuditGoldWithdrawal,
    DeleteGoldWithdrawal
  },
  data() {
    return {
      goldWithdrawalInfo: {
        goldWithdrawals: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          page: 1,
          row: 10,
          goldId: '',
          goldName: '',
          amount: '',
          applyUserName: '',
          applyUserTel: ''
        }
      }
    }
  },
  created() {
    this._listGoldWithdrawals()
    console.log(this.goldWithdrawalInfo.moreCondition)
  },
  methods: {
    queryGoldWithdrawal() {
      this._listGoldWithdrawals(1, 10)
    },
    async _listGoldWithdrawals(page = 1, rows = 10) {
      this.goldWithdrawalInfo.conditions.page = page
      this.goldWithdrawalInfo.conditions.row = rows
      try {
        const res = await listGoldWithdrawal(this.goldWithdrawalInfo.conditions)
        this.goldWithdrawalInfo.total = res.total
        this.goldWithdrawalInfo.records = res.records
        this.goldWithdrawalInfo.goldWithdrawals = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    handleCurrentChange(val) {
      this._listGoldWithdrawals(val, this.goldWithdrawalInfo.conditions.row)
    },
    _openApplyGoldWithdrawalModal() {
      this.$router.push('/pages/admin/applyGoldWithdrawal')
    },
    _openEditGoldWithdrawalModel(row) {
      this.$refs.auditGoldWithdrawalRef.open(row)
    },
    _openDeleteGoldWithdrawalModel(row) {
      this.$refs.deleteGoldWithdrawalRef.open(row)
    },
    _queryGoldWithdrawalMethod() {
      this._listGoldWithdrawals()
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.ibox-title {
  border-bottom: 1px solid #e7eaec;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ibox-content {
  padding: 20px;
}
</style>